import classNames from 'classnames'

import type { ChangeEvent, ReactElement } from 'react'

import Button from '~/components/Buttons/Button'
import SearchInput from '~/components/Inputs/Basic/SearchInput'
import SelectInput from '~/components/Inputs/Basic/SelectInput'

import './styles.scss'

interface Props {
  className?: string
  featureOptions?: IOption[]
  onCreateGroupClick: VoidFunction
  onFeatureIdChange: (options: unknown) => void
  onResetClick: VoidFunction
  onSearchChange: (event: ChangeEvent<HTMLInputElement>) => void
  search: string
  selectedFeatureId: string
}

const ActionsBanner = ({
  className,
  featureOptions,
  onCreateGroupClick,
  onFeatureIdChange,
  onResetClick,
  onSearchChange,
  search,
  selectedFeatureId,
}: Props): ReactElement => {
  /** Local state */

  const componentClasses = classNames('actions-banner-component', className)

  /** Render */

  return (
    <div className={componentClasses}>
      <div className="actions-banner-component__left-section">
        <SearchInput
          className="actions-banner-component__left-section__input"
          defaultValue={search}
          onChange={onSearchChange}
          placeholder="Search"
        />
        <SelectInput
          className="actions-banner-component__left-section__input"
          onChange={onFeatureIdChange}
          options={featureOptions}
          placeholder="Feature"
          value={featureOptions?.find((option) => option.value === selectedFeatureId) || null}
        />
        <Button ghost onClick={onResetClick} size="small">
          Reset
        </Button>
      </div>
      <div className="actions-banner-component__right-section">
        <Button onClick={onCreateGroupClick}>Create new group</Button>
      </div>
    </div>
  )
}

export default ActionsBanner
